import { useQuery } from "@tanstack/react-query";
import { getAboutHeaderSection } from "../../api/apiAboutHeader";

export const useGetAboutHeaderSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["about-header-section"],
        queryFn: getAboutHeaderSection,
    });

    return {
        aboutHeaderSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
